// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, Query } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'

import {
  Spinner,
  EmployeeEmployment,
  IdentityBankAccounts,
  EmployeeContactDetails,
  SvgIcon,
  IdentityWhatsAppSession,
  EmployerCommunications,
  // Payslips,
  SMSMessageComposer,
  EmployeeIdentityDetails as IdentityDetails,
  CheckboxToggle
} from '../../'

import {
  // PayrollRunList,
  Request,
  Requests,
  WhatsAppMessage,
} from '../../../containers'

import {
  decodeBase64,
  hasResponsibility
} from '../../../utils'

// import { REQUESTTYPE_CELLPHONE_NUMBER_CHANGE } from '../../../constants'


const setStateDefault = (identity) => ({
  casesOrderBy: '-created_at',
  payrollRunsOrderBy: '-paid_on',
  loanApplicationOrderBy: '-created_at',
  showCreateCaseModal: false,
  telegramAvailableAsChannel: identity
    ? hasResponsibility(identity.client.division.employer.identity.id, 'messageplus_telegram_employer')
        .then(telegramAvailableAsChannel => telegramAvailableAsChannel)
    : null,
  inviteToTelegram: false,
  inviteToWhatsApp: false
})


class EmployeeDetail extends React.PureComponent {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    detail: PropTypes.string.isRequired,
    objectId: PropTypes.string
  }

  state = setStateDefault(this.props.data.identity)

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data.loading && !this.props.data.loading && this.props.data.identity) {
      const employerIdentityId = this.props.data.identity.client.division.employer.identity.id
      if (employerIdentityId && this.state.telegramAvailableAsChannel === null) {
        hasResponsibility(employerIdentityId, 'messageplus_telegram_employer')
          .then(telegramAvailableAsChannel => (
            this.setState({ telegramAvailableAsChannel })
          ))
      }
    }
  }

  toggleTelegramInvite = (e) => (
    this.setState(prevState => ({
      inviteToTelegram: !prevState.inviteToTelegram,
      inviteToWhatsApp: false
    }))
  )

  toggleWhatsAppInvite = (e) => (
    this.setState(prevState => ({
      inviteToWhatsApp: !prevState.inviteToWhatsApp,
      inviteToTelegram: false
    }))
  )

  getInviteContent = (employerName) => {
    if (this.state.inviteToTelegram) {
      return `${employerName} has invited you to Telegram to receive important notifications. Please click on https://t.me/MessagePlus_sender_bot to register.`
    }
    else if (this.state.inviteToWhatsApp) {
      return `${employerName} has invited you to engage with their MessagePlus WhatsApp menu. Please click on https://wa.me/27600923284 to start.`
    }

    return null
  }

  renderDetail = (detail, objectId) => {
    let identityId = this.props.identityId
    let currentPath = this.props.location.pathname

    const identity = this.props.data.identity
    const client = identity.client

    switch(detail) {
      case 'general':
        return (
          <div className='slds-size_3-of-4 slds-col-rule_right' style={{ paddingTop: '2%', margin: 'auto' }}>
            <IdentityDetails identityId={identityId} />
            <EmployeeEmployment
              client={client.id}
              employer={client.division.employer.id}
            />
            {/* <ClientNotes client={client.id} /> */}
          </div>
        )

      case 'contact':
        return (
          <div className='slds-size_3-of-4 slds-col-rule_right' style={{ paddingTop: '2%', margin: 'auto' }}>
            <EmployeeContactDetails identityId={identityId} />
          </div>
        )

      case 'banking':
        return (
          <div style={{ padding: '2% 1%', margin: 'auto' }}>
            <IdentityBankAccounts identityId={identityId} />
          </div>
        )

      // case 'payslips':
      //   return (
      //     <Fragment>
      //       <div className='slds-text-color_weak'>
      //         <SvgIcon
      //           variant='utility'
      //           symbol='info'
      //           size='small'
      //           colour='light'
      //           className='slds-p-around_small slds-p-left_medium'
      //         />
      //         The following paydays have proof of income in the form of client or employer submitted payslip data.
      //       </div>
      //       <Payslips identityId={identityId} recordsPerPage={10} />
      //     </Fragment>
      //   )

      // comms
      case 'sms_send':
        const { firstName, lastName, fullName, tgId, waId } = this.props.data.identity
        const { inviteToTelegram, inviteToWhatsApp } = this.state

        return (
          <Fragment>
            <div className='slds-p-left_medium slds-p-right_medium slds-p-top_large'>
              {waId === null &&
                <div className='slds-grid'>
                  <CheckboxToggle
                    id='inviteToWhatsApp'
                    checked={inviteToWhatsApp}
                    onChange={this.toggleWhatsAppInvite}
                    className='slds-p-right_small slds-p-bottom_medium'
                    title='This will pre-populate the message box below'
                  />
                  {`Invite ${firstName} to engage with WhatsApp menu`}
                </div>
              }
              {this.state.telegramAvailableAsChannel
                ? tgId === null &&
                  <div className='slds-grid'>
                    <CheckboxToggle
                      id='inviteToTelegram'
                      checked={inviteToTelegram}
                      onChange={this.toggleTelegramInvite}
                      className='slds-p-right_small'
                      title='This will pre-populate the message box below'
                    />
                    {`Invite ${firstName} to receive Telegram messages`}
                  </div>
                : null
              }
            </div>
            <SMSMessageComposer
              fromIdentityId={client.division.employer.identity.id}
              toIdentityId={identityId}
              onMessageCreateSuccess={null}
              onMessageCreateFail={() => this.setState({ messageSendFail: true })}
              termSelectorLabel='Choose term to add at message cursor position'
              terms={[firstName, lastName, fullName]}
              setTemplateContent={this.getInviteContent(client.division.employer.friendlyName)}
              onMessageSentSuccess={() => this.setState({
                inviteToTelegram: false,
                inviteToWhatsApp: false
              })}
              className='slds-m-top_small slds-p-around_medium'
            />
          </Fragment>
        )

      case 'sms':
      case 'whatsapp':
        return (
          <Query
            query={
              gql`
                query($uuid: UUID!, $addressType: String!) {
                  addresses(identity_Id: $uuid, addressType: $addressType) {
                    edges {
                      node {
                        id
                        addressType
                      }
                    }
                  }
                }
              `
            }
            variables={{
              uuid: decodeBase64(identityId),
              addressType: 'msisdn'
            }}>

            {({ loading, error, data }) => {
              if (loading || error) {
                return null
              }

              let addresses = data.addresses.edges
              if (addresses.length > 0) {
                return (
                  <div className='u-bg-color-white'>
                    {detail === 'whatsapp' &&
                      <IdentityWhatsAppSession
                        identityId={identityId}
                        title='Session info'
                        className='slds-p-left_small slds-p-top_small'
                      />
                    }
                    {objectId
                      ? <WhatsAppMessage messageId={objectId} />
                      : <EmployerCommunications
                          identityId={identityId}
                          employerIdentityId={client.division.employer.identity.id}
                          communicationType={detail === 'whatsapp'
                            ? 'WhatsApp'
                            : detail.toUpperCase()  // SMS
                          }
                          urlPath={currentPath}
                          title={null}
                          noStatusFilter={true}
                          key={detail}
                        />
                      }
                  </div>
                )
              } else {
                return (
                  <div className='slds-m-top_large slds-m-left_large'>
                    <SvgIcon
                      variant='utility'
                      symbol='info'
                      colour='light'
                      size='small'
                      className='slds-m-right_medium'
                    />
                    {`Identity has no cellphone address`}
                  </div>
                )
              }
            }}
          </Query>
        )

        case 'requests':
          if (objectId) {
            return <Request id={objectId} />
          } else {
            return (
              <Requests
                title={null}
                identityId={identityId}
                statusFilterInSidebar={true}
                showRequestStatusColumn={true}
                updatedAtSortDefaultDesc={true}
              />
            )
          }

      default:
        return null
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.data.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    return this.renderDetail(this.props.detail, this.props.objectId)
  }
}

const getIdentityDetails = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      firstName
      lastName
      fullName
      identityValue
      membershipStatus
      isClient
      isContact
      tgId
      waId
      client {
        id
        status
        division {
          id
          employer {
            id
            friendlyName
            identity {
              id
            }
          }
        }
        payrollcycle {
          id
          cycle
        }
      }
      contacts {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`

const withData =
  graphql(getIdentityDetails, {
    options: ({ identityId }) => ({
      variables: {
        id: identityId
      }
    })
  })

export default compose(
  withRouter,
  withData,
)(EmployeeDetail)



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-detail/index.js